import React from 'react';
import { Flex } from 'rebass';
import { AmExIcon, MastercardIcon, VisaIcon } from '../Icon/cards';
import { CardPaymentMethod } from './stripe.types';

type Props = {
  method?: CardPaymentMethod | null;
};

const iconHeight = 42;
const iconWidth = 60;

const cardBrandIcon = (brand: string | undefined) => {
  if (!brand) return '💳 Card';
  
  switch (brand.toLowerCase()) {
    case 'visa':
      return <VisaIcon width={iconWidth} height={iconHeight} />;
    case 'mastercard':
    case 'master card':
      return <MastercardIcon width={iconWidth} height={iconHeight} />;
    case 'amex':
    case 'american express':
      return <AmExIcon width={iconWidth} height={iconHeight} />;
    default:
      return '💳 Card';
  }
};

export default function SavedPaymentMethodCard({ method }: Props) {
  if (!method) {
    return (
      <Flex p={4} fontSize="14px" color="#555">
        No payment method on file.
      </Flex>
    );
  }

  return (
    <Flex
      sx={{
        alignItems: 'center',
        lineHeight: '14px',
        justifyContent: 'space-between',
        padding: 4,
        borderRadius: 'default',
        border: '1px solid #e5e5e5',
        boxShadow: 'paymentMethod',
        fontSize: '14px',
        color: '#555',
      }}
    >
      <Flex alignItems="center" sx={{ gap: 2 }}>
        <Flex>{cardBrandIcon(method.brand)}</Flex>****{method.last4}
      </Flex>
      <Flex>
        {method.expMonth && method.expYear && (
          `Expires ${method.expMonth.toString().padStart(2, '0')}/${method.expYear}`
        )}
      </Flex>
    </Flex>
  );
}
